import { computed, inject, Injectable } from '@angular/core';
import { rxResource } from '@angular/core/rxjs-interop';

import { AdvertisementsService } from '../api/api/advertisements.service';
import { showErrorDialogOnFailure, valueOr } from '../shared/resource';

/**
 * Caches the suggested and hotspot advertisements, which are shown on multiple pages.
 * They're fetched the first time this service is injected.
 */
@Injectable({ providedIn: 'root' })
export class AdvertisementSuggestionsService {
  private service = inject(AdvertisementsService);
  private suggestionsResource = rxResource({ stream: () => this.service.listAdvertisementSuggestions() });
  suggestions = computed(() => valueOr(this.suggestionsResource, null));
  loading = this.suggestionsResource.isLoading;

  constructor() {
    showErrorDialogOnFailure(this.suggestionsResource);
  }
}
